import { withStyles } from 'tss-react/mui';
import { TableCell } from '@mui/material';

export const PruTableHeader = withStyles(TableCell, (theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  }
}));